import { useEffect } from 'react';
import { publicAPI } from '../../services/api';

const DynamicFavicon = () => {
  useEffect(() => {
    const loadFavicon = async () => {
      try {
        const response = await publicAPI.getFavicon();
        const faviconUrl = response.data?.faviconUrl;
        
        if (faviconUrl && faviconUrl !== '/favicon.ico') {
          // Remove existing favicon links
          const existingLinks = document.querySelectorAll("link[rel*='icon']");
          existingLinks.forEach(link => link.remove());
          
          // Create new favicon link
          const link = document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'icon';
          link.href = faviconUrl;
          document.getElementsByTagName('head')[0].appendChild(link);
        }
      } catch (error) {
        // Failed to load custom favicon, using default
      }
    };

    loadFavicon();
  }, []);

  return null;
};

export default DynamicFavicon;
